import React from 'react'
import '../Ramz.css'
import Gimm from '../../../assets/Ramz/gimm.mp3'

const Madhiya=()=>{
  return(
    <div className='Flag'>
      <audio controls src={Gimm} type="audio/mpeg"></audio>
      
      <div className='Flag__title'>
      O‘zbekiston Respublikasi Davlat Madhiyasi - O‘zbekistonning bayrog‘i va gerbi qatoridagi asosiy davlat ramzlaridan biridir.
<br/>
O‘zbekiston Respublikasining Davlat Madhiyasi “Serquyosh hur o‘lkam” ashulasi hisoblanadi.
<br/>
O‘zbekiston Respublikasi Oliy Majlisining o‘n birinchi sessiyasida, 1992 yil 10 dekabrda qabul qilingan “O‘zbekiston Respublikasi Davlat Madhiyasi to‘g‘risidagi” qonuni asosida kiritilgan. O‘zbekiston Respublikasi Davlat Madhiyasining birinchi ijrochisi va ijro etaloni O‘zbekiston Milliy simfonik orkestri deb hisoblash rasmiy qabul qilingan (uzb. O‘zbekiston Milliy Simfonik Orkestri).
<br/>
Davlat tadbirlarida, radio va televideniyeda va yana 4 xil uslubda ijro etilishi uchun Madhiya 2006 yil iyul oyida qayta yozib chiqildi: “Jiddiy”, “Odatiy”, “Yoshlarbop” va “Matnsiz”.
<br/>
Abdulla Oripov so‘zi, Mutal (Mutavakkil) Burxonov musiqasi, Ijrochilar (qabul qilingan etalon): O‘zbekiston Milliy Simfonik Orkestri
      </div>
    </div>
  )
}
export default Madhiya